import React from 'react';

export default function Header({ onMenuClick, user }) {
  return (
    <header style={{
      position: 'fixed', top: 0, width: '100%', height: '60px',
      background: '#fff', display: 'flex', alignItems: 'center',
      padding: '0 20px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
      zIndex: 1000, boxSizing: 'border-box', justifyContent: 'space-between'
    }}>
      <button onClick={onMenuClick} style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer' }}>☰</button>
      <span style={{ fontWeight: 'bold', fontSize: '16px' }}>ゆきけん</span>
      <div style={{ width: '24px' }}></div> {/* 中央寄せのためのダミー */}
    </header>
  );
}